import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "locator-map-geo",
  "use": "locator-map-geo-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"locator-map-geo\"><g transform=\"translate(1 1)\" stroke=\"#878787\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\"><circle cx=\"11.862\" cy=\"11.862\" r=\"7.862\" /><circle cx=\"11.862\" cy=\"11.862\" r=\"2.862\" /><path d=\"M12 3.898V0M19.982 11.88h3.898M.12 11.88h3.898M12 23.76v-3.898\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol